$(document).ready(function () {
    // ========================= START :  Home page Testimonial  JS ==================
    $('.testimonial-slider').slick({
            centerMode: true,
            centerPadding: '243px', 
            slidesToShow: 3,
            infinite: true,
            arrows: true,
            dots: false,
            prevArrow: `
                <div class="custom-arrow custom-prev">
                <svg viewBox="0 0 24 24">
                    <path d="M14,17a1,1,0,0,1-.707-.293l-4-4a1,1,0,0,1,0-1.414l4-4a1,1,0,1,1,1.414,1.414L11.414,12l3.293,3.293A1,1,0,0,1,14,17Z"/>
                </svg>
                </div>
            `,
            nextArrow: `
                <div class="custom-arrow custom-next">
                <svg viewBox="0 0 24 24">
                    <path d="M10,7a1,1,0,0,1,.707.293l4,4a1,1,0,0,1,0,1.414l-4,4a1,1,0,1,1-1.414-1.414L12.586,12,9.293,8.707A1,1,0,0,1,10,7Z"/>
                </svg>
                </div>
            `,
            responsive: [
                {
                breakpoint: 1600,
                    settings: {
                        slidesToShow: 3,
                        centerMode: true,
                        centerPadding: '190px',
                        arrows: true,
                        dots: false
                    }
                },
                {
                breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        centerPadding: '0px',
                        arrows: false,
                        dots: true
                    }
                },
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '40px',
                        arrows: false,
                        dots: true
                    }
                }
            ]
    });
    // ========================= END :  Home page Testimonial  JS ==================
    /* ============================= START : MEGA MENU SLIDER  ============================== */
    $('.slick-mega-menu').each(function () {
        let $slider = $(this);
        if ($slider.hasClass('slick-initialized')) return;
        $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
            let $wrapper = $slider.closest('.mega-slider-wrapper');
            let i = (currentSlide ? currentSlide : 0) + 1;
            $wrapper.find('.current').text(i);
            $wrapper.find('.total').text(slick.slideCount);
            let progress = (i / slick.slideCount) * 100;
            $wrapper.find('.slick-progress-bar').css('width', progress + '%');
        });

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            adaptiveHeight: false
        });
    });
    /* ============================= END : MEGA MENU SLIDER  ============================== */


    /* ============================= START: FIX: MENU OPEN (IMPORTANT)============================== */
    $('details').on('toggle', function () {
        if (this.open) {
            let $slider = $(this).find('.slick-mega-menu');
            setTimeout(function () {
                $slider.each(function () {
                    if ($(this).hasClass('slick-initialized')) {
                        $(this).slick('setPosition');
                    }
                });
            }, 200);
        }
    });
    /* ============================= END: FIX: MENU OPEN (IMPORTANT)============================== */


    /* =============================  START : ARROW TOGGLE ============================== */
    document.querySelectorAll('.menu-drawer__menu details').forEach(function (detail) {
        let summary = detail.querySelector('summary');
        let downArrow = summary.querySelector('.down-arrow');
        let upArrow = summary.querySelector('.up-arrow');

        detail.addEventListener('toggle', function () {
            if (detail.open) {
                downArrow.style.display = 'none';
                upArrow.style.display = 'inline-block';
            } else {
                downArrow.style.display = 'inline-block';
                upArrow.style.display = 'none';
            }
        });
    });

    /* =============================  END : ARROW TOGGLE ============================== */

    /* ============================= START : CLOSE BUTTON FIX============================== */
    $('.menu-drawer__close-button').on('click', function () {
        $(this).closest('details').removeAttr('open');
    });
    /* ============================= END : CLOSE BUTTON FIX============================== */

    /* ============================= START : BEST SELLER SLIDER (UPDATED)============================== */
    $('.best-sellers-section').each(function () {
        let $section = $(this);
        let $slider = $section.find('.best-sellers-slider');
        if (!$slider.length || $slider.hasClass('slick-initialized')) return;
        let $thumb = $section.find('.scroll-thumb');
        let $track = $section.find('.custom-scrollbar');
        let $nextBtn = $section.find('.next-btn');
        let $prevBtn = $section.find('.prev-btn');
        let isDragging = false, startX = 0, startLeft = 0, currentLeft = 0;
        function getPageX(e) {
            return e.type.includes('touch')
                ? e.originalEvent.touches[0].pageX
                : e.pageX;
        }
        function updateControls(slick, currentSlide) {
            let totalSlides = slick.slideCount;
            let visibleSlides = slick.options.slidesToShow;
            let maxSlide = totalSlides - visibleSlides;
            $prevBtn.toggleClass('disabled', currentSlide <= 0);
            $nextBtn.toggleClass('disabled', currentSlide >= maxSlide);
            let trackWidth = $track.width();
            if (maxSlide <= 0) {
                $thumb.css({ width: '100%', left: 0 });
                return;
            }
            let thumbWidth = trackWidth * (visibleSlides / totalSlides);
            let progress = currentSlide / maxSlide;

            let left = progress * (trackWidth - thumbWidth);

            $thumb.css({
                width: thumbWidth + 'px',
                left: left + 'px'
            });

            currentLeft = left;
        }
        // INIT EVENT
        $slider.on('init', function (event, slick) {
            setTimeout(() => updateControls(slick, 0), 100);
        });

        // INIT SLIDER
        $slider.slick({
            accessibility: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            speed: 400,
            cssEase: 'ease',
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 2.2 } }
            ]
        });

        // CHANGE
        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            updateControls(slick, nextSlide);
        });

        // BUTTONS
        $nextBtn.on('click', () => $slider.slick('slickNext'));
        $prevBtn.on('click', () => $slider.slick('slickPrev'));

        // DRAG
        $thumb.on('mousedown touchstart', function (e) {
            isDragging = true;
            startX = getPageX(e);
            startLeft = currentLeft;
        });

        $(document).on('mousemove touchmove', function (e) {
            if (!isDragging) return;

            let dx = getPageX(e) - startX;

            let trackWidth = $track.width();
            let thumbWidth = $thumb.width();

            let newLeft = Math.max(0, Math.min(startLeft + dx, trackWidth - thumbWidth));

            currentLeft = newLeft;
            $thumb.css('left', newLeft + 'px');
        });

        $(document).on('mouseup touchend', function () {
            if (!isDragging) return;

            isDragging = false;

            let trackWidth = $track.width();
            let thumbWidth = $thumb.width();

            let progress = currentLeft / (trackWidth - thumbWidth);

            let slick = $slider.slick('getSlick');
            let maxSlide = slick.slideCount - slick.options.slidesToShow;

            let targetSlide = Math.round(progress * maxSlide);
            $slider.slick('slickGoTo', targetSlide);
        });

    });

     /* ============================= END : BEST SELLER SLIDER (UPDATED)============================== */

    // ==================== START: Product  Page size chart btn JS ======================
    (function () {
        var $popup = $(".dimension-popup");

        function openPopup() {
            $popup.css({ opacity: 1, zIndex: 9999 });
        }

        function closePopup() {
            $popup.css({ opacity: 0, zIndex: -1 });
        }

        // ✅ Only button click
        $(document).on("click", ".size-chart-btn", function (e) {
            e.preventDefault();
            openPopup();
        });

        // Close button
        $(document).on("click", ".dimension_popup_close", closePopup);

        // Outside click
        $(document).on("click", ".dimension-popup", function (e) {
            if (!$(e.target).closest(".popup-content").length) {
            closePopup();
            }
        });

    })();
     // ==================== END: Product  Page size chart btn JS ======================

     /* ============================= START : COLLECTION LIST SLIDER============================== */
    $('.custom-collection-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 400,
        centerMode: true,
        centerPadding: '0px',
        prevArrow: `
            <button class="slick-prev custom-arrow">
            <svg viewBox="0 0 100 100">
                <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z"></path>
            </svg>
            </button>
        `,

        nextArrow: `
            <button class="slick-next custom-arrow">
            <svg viewBox="0 0 100 100" style="transform: rotate(180deg);">
                <path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z"></path>
            </svg>
            </button>
        `,

        responsive: [
            {
                breakpoint: 798,
                settings: { slidesToShow: 2.45 }
            }
        ]
    });
     /* ============================= END : COLLECTION LIST SLIDER============================== */

     /* ============================= START :  TESTIMONIAL JS  ============================== */
     $(".testimonial-btn").click(function() {
        var $card = $(this).closest(".testimonial-card");
        var $content = $card.find(".content");
        $content.toggleClass("active");

        // Optional: toggle button text
        if ($content.hasClass("active")) {
        $(this).text("View Less");
        } else {
        $(this).text("Expand");
        }
    });

      /* ============================= END :  TESTIMONIAL JS  ============================== */

    // ======================= Start: Footer Menu Dropdown Js ============================ //
    var $footerWrapper = $('.footer__blocks-wrapper');
    if (!$footerWrapper.length) return;

    function initFooterAccordion() {
        var windowWidth = $(window).width();
        var $menuBlocks = $footerWrapper.find('.footer-block--menu');
        $menuBlocks.removeClass('is-open').find('.footer-block__details-content').css('height', '');
        if (windowWidth > 989) return; 
        $menuBlocks.each(function(index, block) {
            if (index > 2) return; 
            var $block = $(block);
            var $heading = $block.find('.footer-block__heading');
            var $content = $block.find('.footer-block__details-content');
            if (!$heading.length || !$content.length) return;
            $heading.off('click');
            $heading.on('click', function() {
                $block.toggleClass('is-open');
                if ($block.hasClass('is-open')) {
                    $content.stop().animate({ height: $content.prop('scrollHeight') }, 300);
                } else {
                    $content.stop().animate({ height: 0 }, 300);
                }
            });
        });
    }
    initFooterAccordion();
    $(window).on('resize', function() {
        initFooterAccordion();
    });

    // ======================= End: Footer Menu Dropdown Js ============================ //

  
    /* ============================= START : QUICK VIEW POPUP JS  ============================== */
    (function () {
        function initQuickViewScrollbar(container) {
            if (!container || container.querySelector('.thumb-progress')) return;
            const slider = container.querySelector('.thumbnail-slider');
            const scroller = container.querySelector('.thumbnail-list');
            if (!slider || !scroller) return;
            container.dataset.thumbBar = true;
            const wrapper = document.createElement('div');
            const track = document.createElement('div');
            const fill = document.createElement('div');
            wrapper.className = 'thumb-progress';
            track.className = 'thumb-progress-track';
            fill.className = 'thumb-progress-fill';
            track.appendChild(fill);
            wrapper.appendChild(track);
            slider.insertAdjacentElement('afterend', wrapper);
            function update() {
                const scrollWidth = scroller.scrollWidth;
                const clientWidth = scroller.clientWidth;
                const scrollLeft = scroller.scrollLeft;
                const maxScroll = scrollWidth - clientWidth;
                const visiblePercent = scrollWidth > 0
                    ? (clientWidth / scrollWidth) * 100
                    : 0;
                const scrollPercent = maxScroll > 0
                    ? (scrollLeft / maxScroll) * (100 - visiblePercent)
                    : 0;
                fill.style.width = (visiblePercent + scrollPercent) + '%';
            }
            scroller.addEventListener('scroll', () => {
                requestAnimationFrame(update);
            });
            slider.addEventListener('wheel', function (e) {
                e.preventDefault();
                const scrollAmount = e.deltaY || e.deltaX;
                scroller.scrollLeft += scrollAmount;
            }, { passive: false });
            let isDown = false;
            track.addEventListener('mousedown', startDrag);
            track.addEventListener('touchstart', startDrag, { passive: true });
            function startDrag(e) {
                isDown = true;
                move(e);
            }
            window.addEventListener('mousemove', move);
            window.addEventListener('touchmove', move, { passive: false });
            window.addEventListener('mouseup', stopDrag);
            window.addEventListener('touchend', stopDrag);
            function stopDrag() {
                isDown = false;
            }
            function move(e) {
                if (!isDown) return;
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const rect = track.getBoundingClientRect();
                let x = clientX - rect.left;
                let percent = x / rect.width;
                percent = Math.max(0, Math.min(1, percent));
                const maxScroll = scroller.scrollWidth - scroller.clientWidth;
                scroller.scrollLeft = percent * maxScroll;
            }
            update();
            let isDragging = false;
            let startX;
            let scrollStart;
            scroller.addEventListener('mousedown', (e) => {
            isDragging = true;
            scroller.classList.add('is-dragging');
            startX = e.pageX - scroller.offsetLeft;
                scrollStart = scroller.scrollLeft;
            });
            scroller.addEventListener('mouseleave', () => {
                isDragging = false;
                scroller.classList.remove('is-dragging');
            });
            scroller.addEventListener('mouseup', () => {
                isDragging = false;
                scroller.classList.remove('is-dragging');
            });
            scroller.addEventListener('mousemove', (e) => {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.pageX - scroller.offsetLeft;
                const walk = (x - startX) * 1.5;
                scroller.scrollLeft = scrollStart - walk;
            });
        }
        function wrapTitleAndPrice(container) {
            if (!container || container.querySelector('.product-title-price-wrapper')) return;
            const title = container.querySelector('.product__title');
            const price = container.querySelector('.product-price-wrap');
            if (!title || !price) return;
            const wrapper = document.createElement('div');
            wrapper.className = 'product-title-price-wrapper';
            title.parentNode.insertBefore(wrapper, title);
            wrapper.appendChild(title);
            wrapper.appendChild(price);
        }
        // SINGLE OBSERVER
        const observer = new MutationObserver(() => {
            document.querySelectorAll('.quick-add-modal[open]').forEach(modal => {
            initQuickViewScrollbar(modal);
            wrapTitleAndPrice(modal);
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
        });
    })();

    /* ============================= END : QUICK VIEW POPUP JS  ============================== */

    /* ============================= START: ADD TO CART LOADDING TEXT JS ============================== */
    $('.product__info-container .add-to-cart-container .product-form__submit').on('click', function(e) {
        var $button = $(this);
        var $spinner = $('.product__info-container .add-to-cart-container .loading__spinner');
        $button.addClass('loading');
        $spinner.removeClass('hidden');
        setTimeout(function() {
            $button.removeClass('loading');
            $spinner.addClass('hidden');
        }, 3000);
    });
    /* ============================= END: ADD TO CART LOADDING TEXT JS ============================== */


  /* ============================= START: PRODUCT PAGE ACCORDION SMOOTHLY OPEN JS ============================== */

    $(".product__info-wrapper .accordion details").each(function() {
        const $detail = $(this),
        $summary = $detail.find("summary"),
        $content = $detail.find(".accordion__content");
        // Initialize max-height for open details
        if ($detail.prop("open")) {
            $content.css("max-height", $content.prop("scrollHeight") + "px");
        } else {
            $content.css("max-height", "0px");
        }
        $summary.on("click", function(e) {
            e.preventDefault(); // Prevent the default immediate toggle
            if ($detail.prop("open")) {
            $content.css("max-height", $content.prop("scrollHeight") + "px"); // start from full height
            setTimeout(() => {
                $content.css("max-height", "0px"); // animate to 0
            }, 10);
            setTimeout(() => {
                $detail.prop("open", false); // actually close after animation
            }, 310); // slightly longer than CSS transition
            } else {
            // Opening
            $detail.prop("open", true); // first open the detail
            $content.css("max-height", $content.prop("scrollHeight") + "px"); // animate open
            }
        });
     });
  //======================== END:  PRODUCT PAGE ACCORDION SMOOTHLY OPEN JS  =========================   

    /* ============================= START : HEADER ACCORDION JS ============================== */
        const accordionHeaders = document.querySelectorAll('.accordion-header');
            accordionHeaders.forEach(header => {
            header.addEventListener('click', () => {
                const accordionItem = header.closest('.accordion-item'); // safer than parentElement
                const content = header.nextElementSibling;

                if (!content) return; // safety check

                if (accordionItem.classList.contains('active')) {
                // Close this accordion
                content.style.maxHeight = null;
                accordionItem.classList.remove('active');
                } else {
                // Close all others
                document.querySelectorAll('.accordion-item').forEach(item => {
                    item.classList.remove('active');
                    const c = item.querySelector('.accordion__content');
                    if (c) c.style.maxHeight = null;
                });

                // Open this one
                accordionItem.classList.add('active');
                content.style.maxHeight = content.scrollHeight + "px";
                }
            });
            });

    /* ============================= END : HEADER ACCORDION JS ============================== */


    /* ============================= START : PRODUCT PAGE CHAIN VARINT ID UPDATE JS ============================== */
    document.addEventListener('change', function(e) {
    if (e.target.id === 'chain_length') {

        let selectedLength = e.target.value;
        let activeChainType = document.querySelector('.chain-type-option.active');
        let selectedType = activeChainType ? activeChainType.getAttribute('data-type').trim() : null;

        let matchedVariant = window.chain_product.variants.find(v =>
          v.option1 === selectedLength && (!selectedType || v.options.includes(selectedType))
        );
        if (!matchedVariant) return;
        let chainIdInput = document.querySelector('input[name="properties[chain_id]"]');
        if (chainIdInput) {
          chainIdInput.value = matchedVariant.id;
        }
        let chainVariantInput = document.getElementById('chain_variant_id');
        if (chainVariantInput) {
          chainVariantInput.value = matchedVariant.id;
        }
    }
    });
    /* ============================= END : PRODUCT PAGE CHAIN VARINT ID UPDATE JS ============================== */

    /* ============================= START : CART DRAWER RECOMMENDATION ADD TO CART JS ============================== */  
    document.querySelectorAll('.recommendation_item').forEach(item => {
        const s = item.querySelector('.recommendation_item_select');
        const b = item.querySelector('.recommendation_add_to_cart');
        if (s && b && s.options) b.dataset.variantId = [...s.options].find(o => !o.disabled)?.value;
    });

    document.addEventListener('change', e => {
        if (e.target.matches('.recommendation_item_select')) {
            e.target.closest('.recommendation_item')
            ?.querySelector('.recommendation_add_to_cart')
            ?.setAttribute('data-variant-id', e.target.value);
        }
    });

    $(document).on("click",".recommendation_add_to_cart",function() {
         var $button = $(this);
        var ajaxVariantID = $(this).attr('data-variant-id');
           $button.addClass('loading');
            addToCartJS(1,ajaxVariantID,$(this)); 
            setTimeout(function() {
                $button.removeClass('loading');
            }, 2000);
    });

    function addToCartJS(qty, variantID, btn) {
        // Open the cart drawer
        var cartDrawer = document.querySelector('cart-drawer');
        var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
        var sections_url = window.location.pathname;
        // Send request to add item to cart
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ "quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url})
        })
        .then(response => response.json())
        .then(response => {
        cartDrawer.renderContents(response);
        })
        .catch(error => {
            console.error("Error adding item to cart:", error);
        });
    }

    let recommendationSwiper = null;
    $(document).on('click', '.recommendation_title', function () {
        const parent = $(this).closest('.recommendations');
        parent.toggleClass('active');
        if (parent.hasClass('active')) {
            setTimeout(() => {
                initRecommendationSwiper();
            }, 300);
        }
    });

    function initRecommendationSwiper() {
        const sliderEl = document.querySelector('.recommendation_item__slider');

        if (!sliderEl) return;
        if (recommendationSwiper) {
            recommendationSwiper.destroy(true, true);
            recommendationSwiper = null;
        }
        recommendationSwiper = new Swiper(sliderEl, {
            slidesPerView:  2.75,
            slidesOffsetAfter: 0,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            breakpoints: {
                320: {
                    slidesPerView: 2.17
                },
                544: {
                    slidesPerView: 2.75
                }
            },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar"
            }
        });
    }

    
    const recommendations = document.querySelector(".recommendations");

    // Check if there are any swiper slides
    if (!recommendations || recommendations.querySelectorAll(".swiper-slide").length === 0) {
        // Hide the recommendations section if no products
        recommendations.style.display = "none";
    }

    /* ============================= END : CART DRAWER RECOMMENDATION ADD TO CART JS ============================== */  

    
    //  ==========================  START: CartProgress  JS =============================
    const CartProgress = {
        update: function () {
            const cart = document.querySelector('cart-drawer .cart-drawer');
            if (!cart) return;
            const progressCard = cart.querySelector('hitsy-container')?.shadowRoot?.querySelector('hitsy-card');
            if (!progressCard) {
                setTimeout(() => CartProgress.update(), 100);
                return;
            }
            // Inject CSS (only once)
            if (!progressCard.querySelector('.custom-progress-style')) {
                progressCard.insertAdjacentHTML('beforeend', `
                <style class="custom-progress-style">
                .hitsy-card .hitsy-progress-background {
                    height: 20px !important;
                }
                .hitsy-card hitsy-progress {
                    margin-right: 0 !important;
                    -webkit-box-ordinal-group: 6;
                    -ms-flex-order: 5;
                    order: 5;
                    position: relative;
                    margin-bottom: 0;
                }
                .hitsy-card{
                    display:-webkit-box;
                    display:-ms-flexbox;
                    display:flex;
                    -webkit-box-orient:vertical;
                    -webkit-box-direction:normal;
                    -ms-flex-direction:column;
                    flex-direction:column;
                    padding:16px 0 0!important;
                    background:0 0!important;
                    gap:0!important;
                    border:none!important;
                }
                .hitsy-card hitsy-text{
                    text-align:left;
                    -webkit-box-ordinal-group:0;
                    -ms-flex-order:-1;
                    order:-1;
                    padding-right:40px;
                    letter-spacing: 0;
                }
                .hitsy-card hitsy-text > div{
                    text-align:left!important;
                    text-transform:uppercase;
                    font-size:14px!important;
                    font-family:Oswald;
                    color: rgba(0, 0, 0, 0.60) !important;
                    margin: 0 0 0px !important;
                }
                .hitsy-card hitsy-text > div b{
                    color: rgb(0, 0, 0);
                }
                .hitsy-card hitsy-text>div b:not(:last-child){
                    color:#eb001b
                }
                .hitsy-card hitsy-progress{
                    margin-right:0!important;
                    -webkit-box-ordinal-group:6;
                    -ms-flex-order:5;
                    order:5;
                    position:relative;
                    margin-bottom:0;
                }
                .hitsy-card .hitsy-progress-background{
                    height: auto !important;
                    margin-top: 8px;
                }
                .hitsy-card .hitsy-progress-background > div{
                    background-color:#d9dbdc!important;
                    height:8px!important;
                    border-radius:60px!important;
                }
                .hitsy-card .hitsy-progress-background>div>div{
                    background-color:#1c1b1f!important;
                }
                .hitsy-card .hitsy-progress-icon{
                    display:none!important;
                }
                .hitsy-card .cc-cart-drawer-progress{
                    position:absolute;
                    right:0;
                    color:rgba(0,0,0,.6);
                    font-size:14px;
                    font-weight:400;
                    letter-spacing:.08px;
                    text-transform:uppercase;
                    top:-23px;
                    font-family:Oswald;
                }
                hitsy-card{
                    padding-left: 15px;
                    padding-right: 15px;
                    display: block;
                }
                @media (max-width:550px){
                    .hitsy-card .cc-cart-drawer-progress,
                    .hitsy-card hitsy-text>div{
                        font-size:13px!important;
                    }
                }
                </style>
            `);
            }
            const progressEl = progressCard.querySelector('.hitsy-progress-background > div > div');
            // Create percentage text
            if (!progressCard.querySelector('.cc-cart-drawer-progress')) {
                progressCard.querySelector('hitsy-progress')
                .insertAdjacentHTML('afterbegin', '<span class="cc-cart-drawer-progress">0%</span>');
            }
            const percentEl = progressCard.querySelector('.cc-cart-drawer-progress');
            const oldWidth = parseInt(percentEl.textContent) || 0;
            setTimeout(() => {
                if (!progressEl || !progressEl.parentElement) return;
                const newWidth = Math.round(parseFloat(window.getComputedStyle(progressEl).width) / progressEl.parentElement.offsetWidth * 100) || 0;
                if (oldWidth === newWidth) return;
                let current = oldWidth;
                const step = oldWidth < newWidth ? 1 : -1;
                const timer = setInterval(() => {
                    current += step;
                    percentEl.textContent = current + '%';
                    if (current === newWidth) {
                    clearInterval(timer);
                    }
                }, 10);

            }, 300);
        },
        init: function () {
            this.update();
            // observe cart changes (Dawn AJAX fix)
            const target = document.querySelector('cart-drawer');
            if (!target) return;
            const observer = new MutationObserver(() => {
                this.update();
            });
            observer.observe(target, {
                childList: true,
                subtree: true
            });
        }
    };
    (function () {
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            return originalFetch.apply(this, args).then((response) => {
                const url = args[0];
                if (typeof url === 'string' && (
                    url.includes('/cart/add') ||
                    url.includes('/cart/update') ||
                    url.includes('/cart/change') ||
                    url.includes('/cart.js')
                )) {
                    setTimeout(() => {
                        CartProgress.update();
                    }, 300);

                    // 🔁 extra safety (hitsy delay)
                    setTimeout(() => CartProgress.update(), 700);
                }
                return response;
            });
        };
    })();
    document.addEventListener('cart:updated', () => {
        setTimeout(() => CartProgress.update(), 300);
    });

    CartProgress.init();

    //  ==========================  END: CartProgress  JS =============================

    /* ============================= START : CART DRAWER REMOVE PRODUCT BY RELATION_ID JS ============================== */  
    document.addEventListener('click', async (e) => {    
        const removeBtn = e.target.closest('cart-remove-button');
        if (!removeBtn) return;
        e.preventDefault();
        const cartItem = removeBtn.closest('.cart_item');
        if (!cartItem) return;
        const relationId = cartItem.dataset.relationId;
        if (!relationId) {
            const cartItems = removeBtn.closest('cart-items') || removeBtn.closest('cart-drawer-items');
            cartItems.updateQuantity(removeBtn.dataset.index, 0, e);
            return;   
        }
        if (relationId) {
            removeBundleFromCart(relationId);
        }
    });

    // Remove Product Fucntion 
    function removeBundleFromCart(relationId) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        // Get current cart items
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                // Filter items with same relation_id
                const itemsToRemove = cart.items.filter(item => item.properties?.relation_id == relationId || item.properties?.id == relationId);
                if (itemsToRemove.length === 0) return;

                // Prepare updates object
                let updates = {};
                itemsToRemove.forEach(item => {
                    updates[item.key] = 0; // remove item
                });

                // Sections to render (same as addToCartJS)
                const sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.id);
                const sections_url = window.location.pathname;

                // Send request to /cart/update.js
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        updates: updates,
                        sections: sectionsToRender,
                        sections_url: sections_url
                    })
                })
                .then(res => res.json())
                .then(response => {
                    // Render cart drawer contents
                    cartDrawer.renderContents(response);
                })
                .catch(err => {
                    console.error('Error removing bundle:', err);
                });
            })
            .catch(err => console.error('Error fetching cart:', err));
    }

    /* ============================= END :  CART DRAWER REMOVE PRODUCT BY RELATION_ID JS ============================== */  

     /* ============================= START : ENGRAVING PRICE CHANGE UPDATE JS ============================== */
    document.addEventListener('input', function (e) {
        if (!(e.target instanceof Element)) return;
        const changeInputFrontEngraving = e.target.closest('#front_engraving');
        if (changeInputFrontEngraving) {
            let el = document.querySelector('.custom-front-engraving-preview-wrapper .front-preview-input');
            if (el) {
            el.value = changeInputFrontEngraving.value;
            }
        }
    });

    // GLOBAL STATE
    window.customPriceState = {
        basePrice: 0,
        chainPrice: 0,
        engravingTotal: 0
    };

    // HELP: find correct container (product / modal / quick view)
    function getContext(el) {
        return el.closest('.product, .quick-view, .quick-view-modal, quick-add-modal') || document;
    }

    // MAIN PRICE UPDATE
    function updateMainPrice(contextEl) {
        const priceEl = contextEl.querySelector('.product-form__buttons .product-form__submit .price-text');
        if (!priceEl) return;

        // Store base price once per context
        if (!contextEl.dataset.basePrice) {
            let raw = priceEl.textContent.replace(/[^\d]/g, '');
            contextEl.dataset.basePrice = parseInt(raw || 0);
        }

        let basePrice = parseInt(contextEl.dataset.basePrice || 0);
        let { chainPrice, engravingTotal } = window.customPriceState;

        let finalPrice = basePrice + chainPrice + engravingTotal;
        priceEl.textContent = "$" + (finalPrice / 100).toFixed(2);
    }

    // UPDATE LOCATION PRICE
    function updateLocationPrice(contextEl) {
        const selected = contextEl.querySelector('input[name="location"]:checked');
        const priceEl = contextEl.querySelector('.engraving_price_value');

        if (!selected || !priceEl) return;

        priceEl.textContent = selected.getAttribute('data-price') || "0";

        updateEngravingTotal(contextEl);
    }

    // UPDATE ENGRAVING TOTAL
    function updateEngravingTotal(contextEl) {
        const checkbox = contextEl.querySelector('#engraving_checkbox');
        const priceEl = contextEl.querySelector('.engraving_price_value');

        if (!checkbox || !priceEl) return;

        if (!checkbox.checked) {
            window.customPriceState.engravingTotal = 0;
        } else {
            let price = parseInt(priceEl.textContent.replace(/[^\d]/g, '') || 0);
            window.customPriceState.engravingTotal = price;
        }

        updateMainPrice(contextEl);
    }

    // GLOBAL EVENT LISTENER (works for dynamic content)
    document.addEventListener('change', function (e) {
        const target = e.target;
        const contextEl = getContext(target);

        // LOCATION RADIO CHANGE
        if (target.matches('input[name="location"]')) {
            updateLocationPrice(contextEl);
        }

        // ENGRAVING CHECKBOX CHANGE
        if (target.matches('#engraving_checkbox')) {
            updateEngravingTotal(contextEl);
        }
    });

    // INITIAL RUN (for already loaded content)
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.product, .quick-view, .quick-view-modal, quick-add-modal').forEach(contextEl => {
            updateLocationPrice(contextEl);
            updateEngravingTotal(contextEl);
        });
    });
     /* ============================= END : ENGRAVING PRICE CHANGE UPDATE JS ============================== */



    /* =============================START :CART DRAWER QUATITY UPDATE BY RELATION_ID JS ============================== */  

    document.addEventListener('change', async (e) => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        const target = e.target;
        if (!target.matches('.quantity__input')) return;
        const cartItem = target.closest('.cart_item');
        if (!cartItem) return;
        const relationId = cartItem.dataset.relationId;
        if (!relationId) {
            const cartItems = target.closest('cart-items') || target.closest('cart-drawer-items');
            cartItems.updateQuantity(target.dataset.index, parseInt(target.value), event);
            return;   
        }
        try {
            // Get current cart
            const cart = await fetch('/cart.js').then(r => r.json());
            // Find current quantity from main item
            const mainItem = cart.items.find(item => item.properties?.relation_id == relationId || item.properties?.id == relationId);
            if (!mainItem) return;
            // const change = parseInt(target.value) || 0;
            const newQty =  parseInt(target.value);
            // Prepare updates for all items with same relation_id
            const updates = {};
            cart.items.forEach(item => {
            if (item.properties?.relation_id == relationId || item.properties?.id == relationId) {
                updates[item.key] = newQty;
            }
            });
            const sectionsToRender = cartDrawer.getSectionsToRender().map(s => s.id);
            const sections_url = window.location.pathname;

            // Send cart update
            const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates, sections: sectionsToRender, sections_url })
            }).then(r => r.json());

            // Render cart drawer
            cartDrawer.renderContents(response);

        } catch (err) {
            console.error('Bundle quantity update error:', err);
        }
    });
    /* =============================END :CART DRAWER QUATITY UPDATE BY RELATION_ID JS ============================== */ 
    
    /* ============================= START :ON LOAD CHECK ENGRAVING VALUE != blank JS ============================== */

    //    function validateEngraving() {
    //     const button = document.querySelector('[data-btn-add-to-cart]');
    //     if (!button) return;

    //     const engraving_checkbox = document.querySelector('#engraving_checkbox');
    //     const location = document.querySelector('[name="location"]:checked')?.value;

    //     const front = document.querySelector('#front_engraving')?.value.trim() || "";
    //     const back = document.querySelector('#back_engraving')?.value.trim() || "";

    //     let disable = false;

    //     if (engraving_checkbox?.checked) {
    //         if (location === 'front' && !front) disable = true;
    //         if (location === 'back' && !back) disable = true;
    //         if (location === 'both' && (!front || !back)) disable = true;
    //     }

    //     button.disabled = disable;
    // }

    // // Works for normal page interactions
    // document.addEventListener('input', validateEngraving);
    // document.addEventListener('change', validateEngraving);

    // // Handles quick-add modal appearing dynamically (no MutationObserver)
    // let lastRun = 0;

    // setInterval(() => {
    //     const now = Date.now();
    //     if (now - lastRun < 200) return; // throttle

    //     const modalButton = document.querySelector('[data-btn-add-to-cart]');
    //     if (modalButton) {
    //         validateEngraving();
    //         lastRun = now;
    //     }
    // }, 300);

    // // initial run
    // document.addEventListener('DOMContentLoaded', validateEngraving);

    let isOutOfStock = null;

function validateEngraving() {
    const button = document.querySelector('[data-btn-add-to-cart]');
    if (!button) return;

    // ✅ Detect stock state only once per button instance
    if (isOutOfStock === null) {
        isOutOfStock = button.disabled;
    }

    // 🚫 If out of stock → always disabled, no logic runs
    if (isOutOfStock) {
        button.disabled = true;
        return;
    }

    const engraving_checkbox = document.querySelector('#engraving_checkbox');
    const location = document.querySelector('[name="location"]:checked')?.value;

    const front = document.querySelector('#front_engraving')?.value.trim() || "";
    const back = document.querySelector('#back_engraving')?.value.trim() || "";

    let disable = false;

    if (engraving_checkbox?.checked) {
        if (location === 'front' && !front) disable = true;
        if (location === 'back' && !back) disable = true;
        if (location === 'both' && (!front || !back)) disable = true;
    }

    button.disabled = disable;
}

/* =========================
   EVENT LISTENERS
========================= */

// Normal page interactions
document.addEventListener('input', validateEngraving);
document.addEventListener('change', validateEngraving);

// Initial run
document.addEventListener('DOMContentLoaded', validateEngraving);

/* =========================
   QUICK ADD / MODAL SUPPORT
========================= */

let lastRun = 0;

setInterval(() => {
    const now = Date.now();
    if (now - lastRun < 200) return;

    const button = document.querySelector('[data-btn-add-to-cart]');
    if (button) {
        validateEngraving();
        lastRun = now;
    }
}, 300);

    /* ============================= END :ON LOAD CHECK ENGRAVING VALUE != blank JS ============================== */

    /* =============================  START : RELATION ID UPDATE JS ============================== */

    function updateRelationIds() {
        let inputs = document.querySelectorAll('.custom-relation-id');
        let timestamp = Math.floor(Date.now() / 1000);
        inputs.forEach(input => {
            input.value = timestamp;
        });
    }
    // initial run
    updateRelationIds();
    // every second update
    setInterval(updateRelationIds, 1000);

    /* =============================  END : RELATION ID UPDATE JS ============================== */



    // ================================= START :  Quick View Pop up JS Color  Swatch ====================
    document.addEventListener('click', async (e) => {
        const swatch = e.target.closest('.quick-add-modal .pl-swatches__link');
        if (!swatch) return;
        e.preventDefault();
        const quickShopContainer = swatch.closest('.quick-add-modal');
        if (!quickShopContainer) return;
        // Toggle open class on container click (for example)
        quickShopContainer.classList.add('open');
        // Store original content if not already stored
        if (!quickShopContainer.dataset.originalContent) {
            quickShopContainer.dataset.originalContent = quickShopContainer.innerHTML;
        }
        quickShopContainer.classList.add('loading');
        try {
            const productUrl = swatch.getAttribute('href');
            if (!productUrl) return;
            const response = await fetch(productUrl);
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const quickViewTop = doc.querySelector('.quick-view-top');
            const productInfo = doc.querySelector('product-info');
            if (!productInfo) throw new Error('Quick shop product-info content not found');
            const dialogContent = quickShopContainer.querySelector('.quick-add-modal__content');
            if (dialogContent) {
                dialogContent.innerHTML = '';
                if (quickViewTop) dialogContent.appendChild(quickViewTop.cloneNode(true));
                dialogContent.appendChild(productInfo.cloneNode(true));
            } else {
                quickShopContainer.innerHTML = '';
                if (quickViewTop) quickShopContainer.appendChild(quickViewTop.cloneNode(true));
                quickShopContainer.appendChild(productInfo.cloneNode(true));
            }

            // Reinitialize Dawn theme scripts
            if (window.productPage) {
                window.productPage.init();
                window.productPage.runOptionSelector(quickShopContainer);
                window.productPage.productSwatches();
            }
            // IMPORTANT: call after DOM + Dawn init
            setTimeout(() => {
                initPendantLogic(quickShopContainer);
            }, 50);
        } catch (error) {
            console.error('Quickshop error:', error);
        } finally {
            setTimeout(() => quickShopContainer.classList.remove('loading'), 500);
        }
    });

    // Optional: Close modal and restore original content
    document.addEventListener('click', (e) => {
        const modals = document.querySelectorAll('.quick-add-modal');
        if (!modals.length) return;
        modals.forEach((quickShopContainer) => {
            const clickedInside = e.target.closest('.quick-add-modal');
            if (!clickedInside && quickShopContainer.classList.contains('open')) {
                quickShopContainer.classList.remove('open');

                // Restore original content
                if (quickShopContainer.dataset.originalContent) {
                    quickShopContainer.innerHTML = quickShopContainer.dataset.originalContent;
                }
            }
        });
    });
    function initPendantLogic(scope = document) {
      var pendantTabContentEl = scope.querySelector('.product__info-wrapper.grid__item .pendant-tab-content');
      if (!pendantTabContentEl) return;
      var colorSelectorEl = scope.querySelector('.pl-swatches__group.pl-swatches__group--images')?.closest('.shopify-block.shopify-app-block');
      if (!colorSelectorEl) return;
      if (pendantTabContentEl.classList.contains('custom-color-moved')) return;
      var adjustableDiv = pendantTabContentEl.querySelector('.check-chain-adjustable');
      if (!adjustableDiv) return;
      adjustableDiv.insertAdjacentElement('afterend', colorSelectorEl);
      var plSwatchesEl = pendantTabContentEl.querySelector('.pl-swatches__group');
      if (plSwatchesEl && !plSwatchesEl.querySelector('.pl-swatches__label-wrapper')) {
        var labelText = plSwatchesEl.querySelector('.pl-swatches__label')?.innerText;
        var selectedColor = labelText?.split(":")?.pop()?.trim() ?? "";
        plSwatchesEl.insertAdjacentHTML('afterbegin', `
          <div class="pl-swatches__label-wrapper">
            <p class="color-label-heading">Select Color</p>
            <p class="color-label-data">${selectedColor}</p>
          </div>
        `);
      }
      pendantTabContentEl.classList.add('custom-color-moved');
    }

    initPendantLogic();

    //  REAL FIX (Modal Load Detect)
    const quickViewObserver = new MutationObserver(() => {
      const modal = document.querySelector('.quick-add-modal[open], .product-modal[open]');
      if (!modal) return;
      // wait until inner content loads
      const content = modal.querySelector('.product__info-wrapper');
      if (content && !modal.classList.contains('logic-applied')) {
        initPendantLogic(modal);
        modal.classList.add('logic-applied'); // prevent loop
      }
    });
    quickViewObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // ================================= END :  Quick View Pop up JS Color  Swatch ====================

    
    // ==================== START : Input Value Block Script Js ==============
    document.addEventListener('change', function (e) {
        if (e.target.matches('input[name="font_style"]')) {
            const context = e.target.closest('quick-add-modal') || document;
            let inputs = context.querySelectorAll('.engraving_text_input');
            inputs.forEach(input => {
                input.classList.remove('block', 'script');
                input.classList.add(e.target.value);
            });
        }
    });
    // ==================== END : Input Value Block Script Js =============


    // ============================ START:  QUick view Add to cart btn and quantity  Wrap JS ===================
     (function () {
      function initWrapper() {
        $('.quick-add-modal').each(function () {

          var $modal = $(this);

          var $quantity = $modal.find('.product-form__quantity').first();
          var $form = $modal.find('.custom-product-btn-wrapper').first();

          if ($quantity.length && $form.length && !$modal.find('.custom-quickview-wrapper').length) {

            // create wrapper
            var $wrapper = $('<div class="custom-quickview-wrapper"><div class="custom-quickview-wrapper--inner"></div></div>');

            // insert before quantity
            $quantity.before($wrapper);

            // select INNER div
            var $inner = $wrapper.find('.custom-quickview-wrapper--inner');

            // move elements inside INNER div
            $inner.append($quantity);
            $inner.append($form);
          }

        });
      }

      const observer = new MutationObserver(function () {
        initWrapper();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

    })();
    // ============================ END:  QUick view Add to cart btn and quantity  Wrap JS ===================


    
    function initChainLength(scope = document) {
        const select = scope.querySelector("#chain_length");
        const display = scope.querySelector(".custom-chain-option-value");

        if (!select || !display) return;

        // Set initial value
        display.textContent = select.value;

        // Avoid duplicate listeners
        if (!select.dataset.listenerAdded) {
            select.addEventListener("change", function () {
            display.textContent = this.value;
            });
            select.dataset.listenerAdded = "true";
        }
    }

    // Run on initial load
    initChainLength();

    // Watch for Quick Add Modal or dynamic content
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
                initChainLength(node);
            }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});



 document.addEventListener("DOMContentLoaded", function () {
    // ==================================== START : Quick view number landing JS ================================
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('.quick-add__submit.number-landing');
        if (!btn) return;
        setTimeout(() => {
            if (typeof window.initFlxProduct === 'function') {
            window.initFlxProduct();
            }
        }, 2500);
    });

    // ==================================== END : Quick view number landing JS =================================


    document.addEventListener("change", function (e) {
        if (e.target && e.target.id === "select_number") {
            
            const options = document.querySelectorAll(".chain-type-option");
            options.forEach(option => option.classList.remove("active"));

            const first = document.querySelector('.chain-type-option[data-type="3mm Curb Chain"]');

            if (first) {
            first.classList.add("active");
            first.click(); // 🔥 IMPORTANT (price update trigger karega)
            }
        }
    });
});

// ==================  START : Quick view number landing  JS ===============

window.initFlxProduct = function() {
  var CHAR_LIMIT = window.FLX_CHAR_LIMIT || 16;
  var productData = window.flxProductData || {};
  var flxFirstAvailable = window.flxFirstAvailable || null;

  if (!productData || !productData.variants) {
    return;
  }
  var state = { variantId: null, variantPrice: 0, variantCompare: 0, engraving: false, font: 'block', location: 'front' };

    function fmt(cents) {
      if (window.Shopify && window.Shopify.formatMoney) 
        return window.Shopify.formatMoney(cents, document.body.getAttribute('data-money-format') || '{% raw %}${{amount}}{% endraw %}');
      return '$' + (cents / 100).toFixed(2);
    }

    /* Variant resolution */
    window.flxResolveVariant = function() {
      var sels = document.querySelectorAll('.flx-option-select');
      var vals = []; sels.forEach(function(s) { vals.push(s.value); });
      var v = null;
      if (vals.length === 1) v = productData.variants.find(function(x) { return x.option1 && x.option1.toLowerCase().includes(vals[0].toLowerCase()); });
      else if (vals.length === 2) v = productData.variants.find(function(x) { return x.option1 && x.option1.toLowerCase().includes(vals[0].toLowerCase()) && x.option2 && x.option2.toLowerCase().includes(vals[1].toLowerCase()); });
      if (v) { state.variantPrice = v.price; state.variantCompare = v.compare_at_price || 0; state.variantId = v.available ? v.id : null; }
      else { state.variantId = null; state.variantPrice = 0; state.variantCompare = 0; }
      updBtn();
    };

    function updBtn() {
      var btn = document.getElementById('flx-atc');
      var txt = btn.querySelector('.flx-cta-text');
      var compareEl = document.getElementById('flx-price-compare');
      var badgeEl = document.getElementById('flx-price-badge');

      if (state.variantPrice > 0) document.getElementById('flx-price-display').textContent = fmt(state.variantPrice);

      if (state.variantCompare > state.variantPrice) {
        compareEl.textContent = fmt(state.variantCompare);
        compareEl.style.display = '';
        var pct = Math.round((state.variantCompare - state.variantPrice) / state.variantCompare * 100);
        badgeEl.textContent = 'SAVE ' + pct + '%';
        badgeEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
        badgeEl.style.display = 'none';
      }

      if (!state.variantId && state.variantPrice > 0) { btn.classList.add('flx-disabled'); txt.textContent = 'SOLD OUT'; return; }
      if (!state.variantId) { btn.classList.add('flx-disabled'); txt.textContent = 'SELECT OPTIONS'; return; }
      if (state.engraving) {
        var f = document.getElementById('flx-engrave-front'), b = document.getElementById('flx-engrave-back');
        var needFront = (state.location === 'front' || state.location === 'both');
        var needBack = (state.location === 'back' || state.location === 'both');
        if (needFront && f && !f.value.trim()) { btn.classList.add('flx-disabled'); txt.textContent = 'ENTER ENGRAVING TEXT'; return; }
        if (needBack && b && !b.value.trim()) { btn.classList.add('flx-disabled'); txt.textContent = state.location === 'both' ? 'ENTER BACK TEXT' : 'ENTER ENGRAVING TEXT'; return; }
      }
      btn.classList.remove('flx-disabled');
      txt.textContent = 'ADD TO CART \u2014 ' + fmt(state.variantPrice);
    }

    /* Gallery functions */
    window.flxSetImage = function(thumb) {
      document.querySelectorAll('.flx-gallery-desktop .flx-gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      document.getElementById('flx-main-img').src = thumb.getAttribute('data-img');
    };

    if (window.innerWidth <= 860) {
      var flxThumbSlider = new Swiper('.flx-thumb-slider', {
        spaceBetween: 6,
        slidesPerView: 'auto',
        watchSlidesProgress: true
      });
      var flxMainSlider = new Swiper('.flx-main-slider', {
        spaceBetween: 0,
        slidesPerView: 1,
        thumbs: { swiper: flxThumbSlider }
      });
    }

    /* Engraving */
    window.flxToggleEngrave = function() {
      state.engraving = !state.engraving;
      document.getElementById('flx-engrave-toggle').classList.toggle('active', state.engraving);
      document.getElementById('flx-engrave-panel').classList.toggle('open', state.engraving);
      updBtn();
    };
    window.flxSetOpt = function(b, gid) {
      document.getElementById(gid).querySelectorAll('.flx-engrave-opt').forEach(function(o) { o.classList.remove('active'); });
      b.classList.add('active');
      if (gid === 'flx-font-style') state.font = b.getAttribute('data-value');
    };
    window.flxSetLoc = function(loc) {
      state.location = loc;
      var fw = document.getElementById('flx-front-wrap'), bw = document.getElementById('flx-back-wrap'), fl = document.getElementById('flx-engrave-label-front');
      if (loc === 'front') { fw.style.display = ''; bw.style.display = 'none'; fl.textContent = 'Engraving Text'; }
      else if (loc === 'back') { fw.style.display = 'none'; bw.style.display = ''; }
      else { fw.style.display = ''; bw.style.display = ''; fl.textContent = 'Front Engraving Text'; }
      updBtn();
    };
    window.flxCharCount = function() {
      var f = document.getElementById('flx-engrave-front'), b = document.getElementById('flx-engrave-back');
      var strip = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1FA70}-\u{1FAFF}\u{1F1E0}-\u{1F1FF}]/gu;
      f.value = f.value.replace(strip, ''); if (b) b.value = b.value.replace(strip, '');
      document.getElementById('flx-charcount-front').textContent = f.value.length + ' / ' + CHAR_LIMIT;
      if (b) document.getElementById('flx-charcount-back').textContent = b.value.length + ' / ' + CHAR_LIMIT;
      updBtn();
    };

    /* Add to cart logic (same as before) */
    document.getElementById('flx-atc').addEventListener('click', function() {
      var btn = this;
      if (btn.classList.contains('flx-disabled')) return;
      var txt = btn.querySelector('.flx-cta-text');
      txt.textContent = 'ADDING...';
      
      var properties = {};
      if (state.engraving) {
        properties['Engraving'] = 'Yes';
        properties['Font Style'] = state.font;
        properties['Engraving Location'] = state.location;
        var frontVal = document.getElementById('flx-engrave-front') ? document.getElementById('flx-engrave-front').value : '';
        var backVal = document.getElementById('flx-engrave-back') ? document.getElementById('flx-engrave-back').value : '';
        if (state.location === 'front' || state.location === 'both') properties['Front Engraving'] = frontVal;
        if (state.location === 'back' || state.location === 'both') properties['Back Engraving'] = backVal;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: state.variantId, quantity: 1, properties: properties })
      })
      .then(res => { if (!res.ok) throw new Error('Cart error ' + res.status); return res.json(); })
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {
        return fetch('?sections=cart-drawer').then(res => res.json()).then(data => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          var newDrawer = doc.querySelector('.drawer');
          var currentDrawer = document.querySelector('.drawer');
          if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
          document.querySelectorAll('.cart_count').forEach(el => el.textContent = cart.item_count);
          var drawerEl = document.querySelector('[data-cart]');
          if (drawerEl) drawerEl.setAttribute('data-cart', JSON.stringify(cart));
          document.dispatchEvent(new Event('cart:updated'));
          var drawer = document.querySelector('.drawer');
          if (drawer) drawer.classList.add('active');
        });
      })
      .then(() => txt.textContent = 'ADD TO CART — ' + fmt(state.variantPrice))
      .catch(err => { console.error('Cart error:', err); txt.textContent = 'ADD TO CART — ' + fmt(state.variantPrice); window.location.href = '/cart'; });
    });

    /* Auto-select first available variant */
    if (flxFirstAvailable) {
      var sels = document.querySelectorAll('.flx-option-select');
      if (sels.length >= 1 && flxFirstAvailable.option1) { for (var i = 0; i < sels[0].options.length; i++) { if (flxFirstAvailable.option1.includes(sels[0].options[i].value)) { sels[0].selectedIndex = i; break; } } }
      if (sels.length >= 2 && flxFirstAvailable.option2) { for (var i = 0; i < sels[1].options.length; i++) { if (flxFirstAvailable.option2.includes(sels[1].options[i].value)) { sels[1].selectedIndex = i; break; } } }
      flxResolveVariant();
    }
}

// To run the function on page load:
document.addEventListener('DOMContentLoaded', initFlxProduct);

// ==================  End : Quick view number landing  JS ===============

